export default "__VITE_ASSET__cOHvMKUB__"